var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsHeartWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2177_670",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2177_670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.05 16L15.55 12.5C15.8333 12.2167 16.0166 11.8708 16.1 11.4625C16.1833 11.0542 16.1416 10.6583 15.975 10.275C15.8083 9.89167 15.5583 9.58333 15.225 9.35C14.8916 9.11667 14.5166 9 14.1 9C13.6833 9 13.3083 9.12917 12.975 9.3875C12.6416 9.64583 12.3333 9.91667 12.05 10.2C11.75 9.91667 11.4375 9.64583 11.1125 9.3875C10.7875 9.12917 10.4166 9 9.99995 9C9.58328 9 9.20412 9.1125 8.86245 9.3375C8.52078 9.5625 8.26662 9.86667 8.09995 10.25C7.93328 10.6333 7.89578 11.0292 7.98745 11.4375C8.07912 11.8458 8.26662 12.2 8.54995 12.5L12.05 16ZM9.24995 22L8.84995 18.8C8.63328 18.7167 8.42912 18.6167 8.23745 18.5C8.04578 18.3833 7.85828 18.2583 7.67495 18.125L4.69995 19.375L1.94995 14.625L4.52495 12.675C4.50828 12.5583 4.49995 12.4458 4.49995 12.3375V11.6625C4.49995 11.5542 4.50828 11.4417 4.52495 11.325L1.94995 9.375L4.69995 4.625L7.67495 5.875C7.85828 5.74167 8.04995 5.61667 8.24995 5.5C8.44995 5.38333 8.64995 5.28333 8.84995 5.2L9.24995 2H14.75L15.15 5.2C15.3666 5.28333 15.5708 5.38333 15.7625 5.5C15.9541 5.61667 16.1416 5.74167 16.325 5.875L19.3 4.625L22.05 9.375L19.475 11.325C19.4916 11.4417 19.5 11.5542 19.5 11.6625V12.3375C19.5 12.4458 19.4833 12.5583 19.45 12.675L22.025 14.625L19.275 19.375L16.325 18.125C16.1416 18.2583 15.95 18.3833 15.75 18.5C15.55 18.6167 15.35 18.7167 15.15 18.8L14.75 22H9.24995Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsHeartWhite);
export default __webpack_public_path__ + "static/media/SettingsHeartWhite.0640958348cde8fd682cf0e647cbf619.svg";
export { ForwardRef as ReactComponent };